// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7faf69d4","455":"7b71a8d3","977":"439606a3"}[chunkId] + ".chunk.js";
};